export const routes = {
    "/:taskId/initialWorkAdjustmentQuestionnaire": {
        title: "Initial Work Adjustment Questionnaire"
    }
};
